export default __webpack_public_path__ + "static/media/0006.f376a88d.svg";